// extracted by mini-css-extract-plugin
export default {"btop":"c020bb6ddc bf8572f08b _50478a681c","icon":"f90197db10 _84986e9284","btoppink":"bf4a8d72d5 fdb49e03da"};